var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ratings-stars",style:(_vm.starsStyles),attrs:{"aria-label":(_vm.rating + "/5 stars")}})}
var staticRenderFns = []

export { render, staticRenderFns }